import React from 'react';
import { Router } from './routes/index.js'
import { RouterProvider } from 'react-router-dom';
import { UserProvider } from './services/context/UserContext';
import { AppProvider } from './services/context/AppContext.js';
import '@mobiuspack/react-date-range/dist/styles.css'; // main css file
import '@mobiuspack/react-date-range/dist/theme/default.css'; // theme css file

function App() {

  return (
    <AppProvider>
    <UserProvider>
      <RouterProvider
      router={ Router }
      future={{
        v7_startTransition: true,
      }}
      />
    </UserProvider>
    </AppProvider>
)

}

export default App;
